
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, Users, Clock, Wrench } from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen bg-[#222222] text-white py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">About 647.Repair</h1>
        
        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-lg mb-6">
            Founded in 2024, 647.Repair has quickly established itself as a trusted name in appliance repair across the Greater Toronto Area. Our commitment to excellence and customer satisfaction has helped us serve over 300 satisfied clients in our first year of operation.
          </p>
          <p className="text-lg mb-6">
            We specialize in repairing all major appliance brands, providing expert service for dishwashers, dryers, washers, stoves, fridges, and ovens. Our team of skilled technicians brings years of experience and professional expertise to every job.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <Card className="bg-[#333333] border-none">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Shield className="text-blue-400" />
                Insurance & Protection
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-300">
                We are fully insured, providing peace of mind and protection for both our clients and their valuable appliances during every repair service.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-[#333333] border-none">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Users className="text-blue-400" />
                Customer First
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-300">
                Our growing base of over 300 satisfied clients is a testament to our commitment to exceptional service and customer satisfaction.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-[#333333] border-none">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Clock className="text-blue-400" />
                Rapid Response
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-300">
                We understand the urgency of appliance repairs and strive to provide quick, efficient service when you need it most.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-[#333333] border-none">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Wrench className="text-blue-400" />
                Expert Service
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-300">
                Our technicians are trained to work with all major appliance brands, ensuring professional repairs regardless of make or model.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default About;
